import React, { useContext } from 'react';
import useDeductionService from '../../../app/services/hooks/useDeductionServices';
import ActiveControl from '../../../components/ActiveControl';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';

interface Props {
    DeductionId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const DeductionSwitchChange = ({ DeductionId, checkValue, callbackSuccess }: Props) => {
    const [checked, setChecked] = React.useState<boolean>(checkValue);
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { activeDeduction, fetchingActiveDeduction } = useDeductionService();

    const active = (value: boolean) => {
        setChecked(value);

        activeDeduction(DeductionId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={DeductionId} callback={active} />;
};

export default DeductionSwitchChange;
